import { CONFIG } from "@/config";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useActionData, useNavigation } from "react-router-dom";
import { ActionData } from "./createAction";
import SignInButton from "./SignInButton";

export default function SSOPanel() {
  const { t } = useTranslation();
  const showDebugAzureAD = useFeatureFlagEnabled("debug-azure-ad");
  const actionData = useActionData() as ActionData | undefined;
  const { state } = useNavigation();
  const { error, type } = actionData ?? {};
  const hasSSOError = ["microsoft", "google"].includes(type!);
  const hasUserExistsError =
    hasSSOError &&
    error?.code === "auth/account-exists-with-different-credential";

  const [stayLoggedIn, setStayLoggedIn] = useState(false);

  return (
    <div className="mt-6 grid grid-cols-3 gap-3">
      {hasSSOError &&
        (hasUserExistsError ? (
          <div className="col-span-3">
            <p className="sm:text-sm">
              <ExclamationTriangleIcon className="mx-1 inline h-4 w-4 text-red-600" />
              {t("je-hebt-al-een-account-met-dit-email-adres")}
              <a
                className="mx-1 text-blue-500 hover:text-blue-600 hover:underline sm:text-sm"
                href={createMailTo()}
              >
                {t("contacteer-tiro-health-om-je-account-te-switchen")}
              </a>
            </p>
          </div>
        ) : (
          <p className="col-span-3 text-red-600">{error?.message}</p>
        ))}
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @uzleuven.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="uzleuven" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @azgroeninge.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="azgroeninge" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @mijnziekenhuis.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="azmm" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @azturnhout.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="azturnhout" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @azvesalius.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="azvesalius" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @yperman.net
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="yperman" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @asz.be
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="asz" />
        </form>
      </div>
      <div className="col-span-3">
        <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
          <SignInButton type="submit" disabled={state == "submitting"}>
            @tiro.health
          </SignInButton>
          <input type="hidden" name="next" value={window.location.href} />
          <input type="hidden" name="provider" value="tiro-google" />
        </form>
      </div>
      {(showDebugAzureAD || CONFIG.isDev) && (
        <div className="col-span-3">
          <form method="GET" action={`${CONFIG.AUTH_SERVER}/entra/login`}>
            <SignInButton type="submit" disabled={state == "submitting"}>
              @tiro.health (Microsoft Entra)
            </SignInButton>
            <input type="hidden" name="next" value={window.location.href} />
            <input type="hidden" name="provider" value="tiro-entra" />
          </form>
        </div>
      )}
      <div className="col-span-3 flex items-center">
        <input
          id="sso-stay-logged-in"
          type="checkbox"
          checked={stayLoggedIn}
          onChange={(event) => setStayLoggedIn(event.target.checked)}
          className="h-4 w-4 rounded border-gray-light text-blue-primary focus:ring-blue-500"
        />
        <label
          htmlFor="sso-stay-logged-in"
          className="ml-2 block text-sm text-gray-700"
        >
          {t("blijf-ingelogd-op-deze-computer")}
        </label>
      </div>
    </div>
  );
}

function createMailTo() {
  const subject = "Wijzigen van login methode.";
  const message = encodeURI(`Beste,
  Op dit moment log ik in met email/passwoord maar ik zou graag inloggen via Single-Sign-On van het ziekenhuis.
  Mijn email adres is: <vul hier je email adres in>

  Vriendelijke groeten,

  Axel`);
  return `mailto:admin@tiro.health?subject=${subject}&body=${message}`;
}
